import { createRouter, createWebHistory } from 'vue-router'
import PcApp from '@/PcApp.vue'
import MobileHome from '@/pages/mobile/MobileHome.vue'
import MobileApp from '@/pages/mobile/MobileApp.vue'
import MobileRelease from '@/pages/mobile/MobileRelease.vue'
import MobileRegister from '@/pages/mobile/MobileRegister.vue'
import MobileSuccess from '@/pages/mobile/MobileSuccess.vue'
import MobileProducts from '@/pages/mobile/MobileProducts.vue'
import MobileEmployee from '@/pages/mobile/MobileEmployee.vue'
import MobileOrder from '@/pages/mobile/MobileOrder.vue'
import MobileUser from '@/pages/mobile/MobileUser.vue'
import MobileLogin from '@/pages/mobile/MobileLogin.vue'
import MobileAbout from '@/pages/mobile/MobileAbout.vue'
import MobileOrders from '@/pages/mobile/MobileOrders.vue'
import MobileOrderDetail from '@/pages/mobile/MobileOrderDetail.vue'
import MobileAddress from '@/pages/mobile/MobileAddress.vue'
import MobileProfile from '@/pages/mobile/MobileProfile.vue'
import DocumentShare from '@/pages/DocumentShare.vue'
import { isMobileDevice } from '@/device/platform'

function parseLegacyHashRoute() {
  const rawHash = window.location.hash.replace(/^#/, '')
  if (!rawHash) return null
  const [legacyPath, legacyQuery = ''] = rawHash.split('?')
  const query = Object.fromEntries(new URLSearchParams(legacyQuery))
  if (legacyPath === '/register') return { path: '/mobile/register', query }
  if (legacyPath === '/download') return { path: '/mobile/download', query }
  return null
}

const routes = [
  { path: '/', redirect: () => parseLegacyHashRoute() || (isMobileDevice() ? '/mobile' : '/pc') },
  { path: '/pc', component: PcApp },
  { path: '/pc/:pathMatch(.*)*', component: PcApp },
  { path: '/mobile', component: MobileHome },
  { path: '/mobile/products', component: MobileProducts },
  { path: '/mobile/employee', component: MobileEmployee },
  { path: '/mobile/order', component: MobileOrder },
  { path: '/mobile/user', component: MobileUser },
  { path: '/mobile/login', component: MobileLogin },
  { path: '/mobile/orders', component: MobileOrders },
  { path: '/mobile/orders/:id', component: MobileOrderDetail },
  { path: '/mobile/address', component: MobileAddress },
  { path: '/mobile/profile', component: MobileProfile },
  { path: '/mobile/about', component: MobileAbout },
  { path: '/mobile/app', component: MobileApp },
  { path: '/mobile/download', component: MobileRelease },
  { path: '/mobile/register', component: MobileRegister },
  { path: '/mobile/register/success', component: MobileSuccess },
  { path: '/mobile/agreement/:key', component: MobileRegister },
  { path: '/share/doc/:token', component: DocumentShare },
  { path: '/register', redirect: to => ({ path: '/mobile/register', query: to.query }) },
  {
    path: '/download',
    redirect: to => ({
      path: isMobileDevice() ? '/mobile/download' : '/pc/download',
      query: to.query
    })
  },
  { path: '/about', redirect: '/pc/about' },
  { path: '/culture', redirect: '/pc/culture' },
  { path: '/order/:pathMatch(.*)*', redirect: to => `/pc${to.path}` },
  { path: '/user/:pathMatch(.*)*', redirect: to => `/pc${to.path}` },
  { path: '/:pathMatch(.*)*', redirect: () => parseLegacyHashRoute() || (isMobileDevice() ? '/mobile' : '/pc') }
]

export default createRouter({ history: createWebHistory(), routes, scrollBehavior: () => ({ top: 0 }) })
